import datasetParser from "@Dataset/datasetParser";
import {BestPriceTab} from "@Pages/stationToStation/features/bestPriceTabs/components/BestPriceTab";
import Row from "@Containers/components/Row";
import {useEffect, useState} from "react";

interface BestPriceTabsProps {
    bestPriceOnDateRoutes?: Record<string, any>
    tab?: string
    setTab?: (tab: string) => void
}

export const BestPriceTabs = ({bestPriceOnDateRoutes, tab, setTab}: BestPriceTabsProps) => {
    const parsedData = bestPriceOnDateRoutes || datasetParser({id: 'result-tabs'})
    const [activeTab, setActiveTab] = useState(Object.keys(parsedData?.bestPriceOnDateRoutes)[0])

    useEffect(() => {
        const currentActiveTab = document.querySelector('.tab-pane.active');
        if (currentActiveTab) {
            currentActiveTab.classList.remove('active');
        }
        const newActiveTab = document.getElementById(`panel__${tab || activeTab}`);
        if (newActiveTab) {
            newActiveTab.classList.add('active');
        }
    }, [activeTab]);

    return (
        <Row>
            {Object.keys(parsedData?.bestPriceOnDateRoutes).map((id: string) => (
                <BestPriceTab
                    active={activeTab === id}
                    onClick={() => {
                        if (setTab) {
                            setTab(id)
                        }
                            setActiveTab(id)
                    }}
                    key={`tab__${id}`}
                    tab={id}
                    routes={parsedData?.bestPriceOnDateRoutes[id].length}
                />
            ))}
        </Row>
    );
}